import axios from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";
import { catchAxiosError } from "./complex";

export const CreateDeal= (body) => {

  return axiosInstance
    .post(`/deal/createNewDeal`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const UpdateDeal = (body) => {
    return axiosInstance
      .put(`/deal/${body.id}`, body)
      .then((response) => {
       return response.data.response[0];
      })
      .catch((error) => {
         var response = catchAxiosError(error);
         return response;
      });
  };
  
  export const DeleteDeal = (id) => {
    return axiosInstance
      .delete(`/deal/deleteDeal/${id}`)
      .then((response) => {
        return response.data.response[0];
      })
      .catch((error) => {
        catchAxiosError(error);
      });
  };

  export const getDeal = (id) => {
    return axiosInstance
      .get(`/deal/getDealById/${id}`)
      .then((response) => {
        
        return response.data.response[0];
      })
      .catch((error) => {
        catchAxiosError(error);
      });
  };
  
  export const getAllDeals = () => {
    return axiosInstance
      .get(`/deal/getAllDeals`)
      .then((response) => {
        
        return response.data.response; 
      })
      .catch((error) => {
        catchAxiosError(error);
      });
  };
  
